import api from './api';

const dashboardService = {
  /**
   * Get dashboard statistics
   * @param {string} startDate - Start date (YYYY-MM-DD)
   * @param {string} endDate - End date (YYYY-MM-DD)
   * @returns {Promise} Dashboard stats
   */
  getStats: async (startDate, endDate) => {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    const queryString = params.toString();
    const url = queryString ? `/api/dashboard/stats?${queryString}` : '/api/dashboard/stats';
    const response = await api.get(url);
    return response.data;
  },

  /**
   * Get order statistics for a date range
   * @param {string} startDate - Start date (YYYY-MM-DD)
   * @param {string} endDate - End date (YYYY-MM-DD)
   * @returns {Promise} Order statistics
   */
  getOrderStats: async (startDate, endDate) => {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    const response = await api.get(`/api/dashboard/order-stats?${params.toString()}`);
    return response.data;
  },

  /**
   * Get revenue statistics
   * @param {string} period - Period (daily, weekly, monthly)
   * @returns {Promise} Revenue data
   */
  getRevenueStats: async (period = 'daily') => {
    const response = await api.get(`/api/dashboard/revenue?period=${period}`);
    return response.data;
  },

  /**
   * Get recent orders for dashboard
   * @param {number} limit - Number of orders to fetch (default: 5)
   * @returns {Promise} Array of recent orders
   */
  getRecentOrders: async (limit = 5) => {
    const response = await api.get(`/api/orders?limit=${limit}&page=1`);
    return response.data;
  },

  /**
   * Get today's order summary
   * @returns {Promise} Today's order statistics
   */
  getTodaySummary: async () => {
    const today = new Date().toISOString().split('T')[0];
    const response = await api.get(`/api/orders?startDate=${today}&endDate=${today}`);
    return response.data;
  },

  /**
   * Get pending pickups count
   * @returns {Promise} Count of orders pending pickup
   */
  getPendingPickups: async () => {
    const response = await api.get('/api/orders?orderStatus=Pick-up Pending&limit=1000');
    return response.data;
  },

  /**
   * Get pending deliveries count
   * @returns {Promise} Count of orders pending delivery
   */
  getPendingDeliveries: async () => {
    const response = await api.get('/api/orders?orderStatus=Delivery Pending&limit=1000');
    return response.data;
  },
};

export default dashboardService;
